export default "__VITE_ASSET__DRsFN91L__"